<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('blog_category')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <a class="nav-link btn btn-primary btn-with-shadow"
                       href="/blog/category/add">
                         {{ $t('add') }}       
                    </a>  
                </div>
            </div>
        </div>
        <app-table :id="tableId" :options="options" @action="getListAction"/>       

        <app-delete-modal v-if="deleteConfirmationModalActive"
                                :preloader="deleteLoader"
                                modal-id="demo-delete"
                                @confirmed="confirmed"
                                @cancelled="cancelled"/>
    </div>
</template>

<script>
    import {TableHelpers} from './mixins/TableHelpers';
    import * as actions from '../../../../../Config/ApiUrl';
    import {FormMixin} from "../../../../../../core/mixins/form/FormMixin";
 

    export default {
        name: "BlogCategory",
        mixins: [TableHelpers,FormMixin],
        data() {
            return {
                deleteConfirmationModalActive: false,
                deleteLoader: false,
                tableId: 'blog-category-table',
                rowData: {},
                options: {
                    name: 'CategoryTable',
                    url: actions.GET_BLOG_CATEGORY,
                    showHeader: true,
                    columns: [],
                    actions: [
                        {
                            title: this.$t('edit'),
                            icon: 'edit',
                            type: 'none',
                            

                        }, {
                            title: this.$t('delete'),
                            icon: 'trash',
                            type: 'none',
                            component: 'app-confirmation-modal',
                            modalId: 'demo-delete',
                        }
                    ],
                    filters: [ 
                        {
                            "title": this.$t('search_and_select'),
                            "type": "search",
                            "key": "search",
                        }
                    ],
                    showFilter: true,
                    showSearch: true,
                    paginationType: "pagination",
                    responsive: true,
                    rowLimit: 10,
                    showAction: true,
                    orderBy: 'desc',
                    actionType: "default",
                }
            }
        },

        created(){
            this.options.columns = [...this.tableColumns, this.actionObj];
        },
        methods: {
            /**
             * $emit Form datatable action
             */
            getListAction(rowData, actionObj, active) {

                this.rowData = rowData;

                if (actionObj.title == 'Delete') {

                    this.openDeleteModal();
                } else if (actionObj.title == this.$t('edit')) {

                  window.location = `${actions.EDIT_BLOG_CATEGORY}${this.rowData.id}`;
                }
            },

            /**
             * for open confirmation modal
             */
            openDeleteModal() {
                this.deleteConfirmationModalActive = true;
            },

            /**
             * confirmed $emit Form confirmation modal
             */
            confirmed() {
                let url = `${actions.DELETE_BLOG_CATEGORY}${this.rowData.id}`;
                console.log(url);
                this.deleteLoader=true;
                this.axiosDelete(url)
                    .then(response => {
                        this.deleteLoader= false;
                        $("#demo-delete").modal('hide');
                        this.cancelled();
                        this.$toastr.s(response.data.message);
                    }).catch(({error}) => {

                    //trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
            },

            /**
             * cancelled $emit Form confirmation modal
             */
            cancelled() {
                this.deleteConfirmationModalActive = false;
                this.reSetData();
            },

            reSetData() {
                this.rowData = {};
            },
        },
    }
</script>
